import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Jinwoo Park
 * @contact libfairy720@datasolution.kr
 * @date 2023-09-19
 * @brief SEI Management - 사용자 관리 개발
 *
 ********************************************************************/
import { useEffect, useState } from "react";
//
import { useAsync } from "react-async";
// recoil && state
import { useRecoilValue } from "recoil";
import { userInfoLoginState } from "../../../recoil/userState";
//
import { useNavigate } from "react-router-dom";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CONST from "../../../utils/Const";
/**
 * @brief EHP 사용자 관리 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
export default function UserTree(props) {
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    // 화면 이동
    const navigate = useNavigate();
    // props
    const { selTree, setSelTree } = props;
    const [companyDto, setCompanyDto] = useState([]);
    const { data: data, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/user/companies`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: selTree.reload,
    });
    useEffect(() => {
        // error page 이동
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, data);
        if (ERR_URL.length > 0)
            navigate(ERR_URL);
        if (data) {
            if (data.codeNum == CONST.API_200) {
                let body = data.body;
                let companys = [{ companyName: "SEI 커뮤니티" }];
                body.forEach((element) => {
                    companys.push(element);
                });
                setCompanyDto(companys.map((item) => (Object.assign(Object.assign({}, item), { companyId: item.companyName.split(" ")[0] == "SEI" ? item.companyName.split(" ")[0] : item.companyName }))));
                setSelTree({
                    company: {
                        companyId: companys[0].companyName.split(" ")[0] == "SEI"
                            ? companys[0].companyName.split(" ")[0]
                            : companys[0].companyName,
                        companyName: companys[0].companyName,
                    },
                    reload: true,
                });
            }
        }
    }, [data]);
    function onclickCompany(name, id) {
        setSelTree({
            company: { companyId: id, companyName: name },
            reload: true,
        });
    }
    const treeItem = companyDto == null ? null : companyDto;
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: "box treebar pushy-menutype type3" }, { children: [_jsx("div", Object.assign({ className: "box__header" }, { children: _jsx("p", Object.assign({ className: "list-info tit" }, { children: "*\uC0AC\uC6A9\uC790 \uC18C\uC18D \uAE30\uC900" })) })), _jsx("div", Object.assign({ className: "lnb" }, { children: _jsx("ul", Object.assign({ className: "lnb-depth1" }, { children: treeItem.map((tree, idx) => (_jsx("li", Object.assign({ className: tree.companyId == selTree.company.companyId ? "active" : "", onClick: (e) => onclickCompany(tree.companyName, tree.companyId) }, { children: _jsx("p", { children: _jsx("a", Object.assign({ href: "#", onClick: (e) => e.preventDefault() }, { children: _jsx("span", { children: tree.companyName }) })) }) }), "companyTree_" + idx))) })) }))] })) }));
}
